var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('el-col',{attrs:{"xl":5,"lg":7,"md":7,"span":11,"xs":23,"offset":1}},[_c('el-form-item',_vm._b({},'el-form-item',_vm.$attrs,false),[_vm._t("default"),_vm._t("label",null,{"slot":"label"})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }